<template>
    <div>
        <div>
            <el-button type="success"
                style="margin-bottom:10px"
                @click="allBeginDown()" :disabled="downloading">
               一键预加载
            </el-button>
            <el-tag type="info" style="margin-left: 15px;text-align: center" v-show="downloading">
                <span>加载中，请勿离开或刷新此页面</span><i class="el-icon-loading"></i>
            </el-tag>
        </div>
        <my-table :data="tableData" :height="tableHeight">
            <el-table-column label="标段名称" prop="bdname"></el-table-column>
            <el-table-column label="标段编码" prop="bdcode"></el-table-column>
            <el-table-column label="合同估算价" prop="htgsj"></el-table-column>
            <el-table-column label="本机预加载情况" >
                <template slot-scope="scope">
                    <!-- {{jzData}} -->
                <div v-html="jzData[scope.$index].jzqk">
                </div>
                </template>
            </el-table-column>
            <el-table-column label="预加载" >
                <template slot-scope="scope">
                    <my-btn
                        type="detail"
                        @click="jiaZai(scope.row.bdcodejm)">
                        查看预加载详细情况
                    </my-btn>
                    <el-button  style="margin-left: 5px;" size="small" type="text" @click="bdjiaZai(scope.row.bdcodejm,scope.$index)" :disabled="downloading"><i class="el-icon-check "></i>开始预加载</el-button>
                </template>
            </el-table-column>
        </my-table>
        <object id="certMgrObj" classid="CLSID:59B3BFD5-6CC5-4FFA-90E8-C1E5AFCB42E9" width="1" height="1" viewastext> </object>
        <el-dialog 
        title="评标环境预加载-投标单位列表 " 
        :visible.sync="dialogVisible" 
        :before-close="dialogClose"
        width="1200px"
        >
            <yjzwj
                v-if="dialogVisible"
                :data="dialogData"
            ></yjzwj>
        </el-dialog>
    </div>
</template>

<script>
import LIST_PAGE_MIXIN from '@views/mixins/list-page'
import yjzwj from './yu-jia-zai-wen-jian'
export default {
    mixins: [LIST_PAGE_MIXIN, ],
    components: { 
        yjzwj
    },
    data() {
        return {
            tableData:[],
            jzData:[],
            Util:{},
            progress:[],
            dialogData:{},
            dialogVisible:false,
            bdtabledata:[],
            downloading:false,
            // jzqk:''
        }
    },
    computed: {
        query() {
            return this.getQuery()
        }
    },
    methods: {
        bdjiaZai(bdcodejm,index) {
            var errorFileList = [];
            console.log(index)
            this.jspInit(`${this.getGetters('bidUrl')}/newpingbiao/pbwyh/pwtbwjyjz.json`, 
                { 
                    bdcode:bdcodejm
                }
            , data => {
                this.bdtabledata=data.listData
                this.downloading = true;
                for(var n = 0; n < this.bdtabledata.length; n++){ 
                    var theFileInfo = this.bdtabledata[n];
                    if (!theFileInfo.pdfFile||!theFileInfo.pdfSha1){      
                        errorFileList.push(theFileInfo);                
                    }else {
                        this.downPdf(this.bdtabledata[n].pdfFile,this.bdtabledata[n].tbdwcode,this.bdtabledata[n].pdfSha1,false);
                    }
                } 
                this.checkPdfExit(this.tableData[index].pdfFileList, this.tableData[index].bdcode);
                if (errorFileList.length>0){
                    ShowMsg("标段编号："+this.tableData[index].bdcode+"下有"+errorFileList.length+"个文件有异常")
                    this.downloading = false;
                    return
                }
                if(this.tableData[index].pdfFileList.length>=1) {
                    ShowMsg('该标段预加载完成','success')
                }else{
                    ShowMsg('无可加载的文件','warning')
                }
                this.downloading = false;
            });  
        },
        getClientSha1(filePathName) {
            var u = certMgrObj.Util;
            return  u.HashFile(filePathName,1,function (){return true});
        },
        downPdf(downUrl,tbdwcode,pdfSha1,bDown) {
            // this.sum = this.sum + 1
        
            // this.dbdpercent =  Math.round(parseFloat(this.sum / this.progress.length) * 100); 
            var that = this;
            try {
				downUrl = downUrl.replace(/\\/g,'/');
				certMgrObj.Licence = "amViY56Xmp2cnpeanZyel5qdnJ6Xmp2cYWhlYoQsftgudcLw21NcfvO8eN13ICbS";
				var u = certMgrObj.Util;
				var strs = downUrl.split("/");
                var fileName='';
                fileName = strs[strs.length-1];
                var folderName = strs[strs.length-4]+"\\"+strs[strs.length-3]+"\\"+strs[strs.length-2];
                var filePath = u.GetFolderPath(5) +"hbidding"+"\\"+folderName;
                u.CreateDir(filePath) ; 
                var file = filePath+"\\"+fileName;
                //单个下载
                if(bDown) {
                    u.Download( downUrl, file, OpCallback);
                    return;
                }
                //存在显示
                if (u.FileExists(file)&&this.getClientSha1(file)==pdfSha1 ) {
                    for(var i=0;i<that.progress.length;i++) {
                                if(that.progress[i].tbdwcode==tbdwcode) {
                                    that.progress[i].wanzheng= true
                                }
                            }
                    for(var i=0;i<that.progress.length;i++) {
                        
                        if(that.progress[i].tbdwcode==tbdwcode) {
                            that.progress[i].percent= 100 
                        }
                   
                    } 
                    

                } else{//不存在下载
         
                    u.Download( downUrl, file, OpCallback);
                } 	 
                var allCount = 0;
			    function OpCallback (message, value) {
					 if (message == 1) {
                       
						if (value == 0) {
							//alert("开始操作,未知文件长度");
						} else {
							allCount = value;
						}
					} else if (message == 2) {
                   
                        for(var i=0;i<that.progress.length;i++) {
                            if(that.progress[i].tbdwcode==tbdwcode) {
                                that.progress[i].percent= Math.round(parseFloat(value / allCount) * 100); 
                            }
                        }
					} else {
                     
                         for(var i=0;i<that.progress.length;i++) {
                            if(that.progress[i].tbdwcode==tbdwcode) {
                                that.progress[i].percent= 100 
                                that.progress[i].wanzheng= true
                            }
                        }
			            // that.YzWzx();
               
               
					}
					return true; 
	    		}
			} catch (e) {
				//alert("失败" + e.message)
			}
        },
        allBeginDown() {
            var errorBdcodeList =[];
            var errorFileListLength=[];
            var str=''
            this.downloading = true;
            for (var k = 0; k < this.tableData.length; k++) {
                var pdfFileList = this.tableData[k].pdfFileList;
                var bdcode = this.tableData[k].bdcode;
                var errorFileList = [];
                for (var i = 0; i < pdfFileList.length; i++) {
                    var theFileInfo = pdfFileList[i];
                    if (!theFileInfo.pdfFile||!theFileInfo.pdfSha1){
                        errorFileList.push(theFileInfo);
                    }else {
                        this.downPdf(theFileInfo.pdfFile,theFileInfo.tbdwcode,theFileInfo.pdfSha1,false);
                    }      
                } 

                if (errorFileList.length>0){
                    errorFileListLength.push(errorFileList.length)
                    errorBdcodeList.push(bdcode);
                }
                this.checkPdfExit(pdfFileList, bdcode);
            }
            if(this.progress.length<1) {
                ShowMsg('无可加载的文件','warning')
                this.downloading = false;
            }
            if(errorBdcodeList.length>1){
                for(var i=0;i<errorBdcodeList.length;i++) {
                    str= str+'标段编号：'+errorBdcodeList[i]+'下有'+errorFileListLength[i]+'个文件有异常；'
                }
                ShowMsg(str,'error')
                this.downloading = false;
                return
            }

            if(this.progress.length>=1) {
                ShowMsg('一键预加载完成','success')
                this.downloading = false;
            }   
        },
        jiaZai(bdcodejm) {
            this.dialogVisible = true
            this.dialogData = {
                progress:this.progress,
                bdcodejm:bdcodejm,
            }
            // this.goto({
            //     path:'./pwtbwjyjz',
            //     query: {
            //         bdcodejm: bdcodejm,
            //     }
            // })
        },
        dialogClose() {
            for (var m = 0; m < this.tableData.length; m++) {
                this.checkPdfExit(this.tableData[m].pdfFileList, this.tableData[m].bdcode);
            }
            // this.sumclose = 0
            //     console.log(1)
            // for(var i = 0;i<this.progress.length;i++) {
            //     if(this.progress[i].percent===100) {
            //         this.sumclose=this.sumclose+1
            //     }
            // }
            // this.dbdpercent =  Math.round(parseFloat(this.sumclose / this.progress.length) * 100); 
            // console.log(this.dbdpercent)
            // this.shuaxin = false
            // this.$nextTick(function(){
            //     this.shuaxin = true
            // })
            this.dialogVisible = false
        },
        checkPdf(downUrl,tbdwcode,pdfsha1) {
             try {
            downUrl=downUrl.replace(/\\/g,'/');
            certMgrObj.Licence = "amViY56Xmp2cnpeanZyel5qdnJ6Xmp2cYWhlYoQsftgudcLw21NcfvO8eN13ICbS";
			var u = certMgrObj.Util;	
		    var strs = downUrl.split("/"); 
            var fileName = strs[strs.length-1];
            var folderName = strs[strs.length-4]+"\\"+strs[strs.length-3]+"\\"+strs[strs.length-2];
            var filePath = u.GetFolderPath(5) +"hbidding"+"\\"+folderName;
            var file = filePath+"\\"+fileName; 
            if (u.FileExists(file))//存在显示
            {
              if(this.getClientSha1(file)==pdfsha1)
              {      
                for(var i=0;i<this.progress.length;i++) {
                    if(this.progress[i].tbdwcode==tbdwcode) {
                        this.progress[i].wanzheng= true
                    }
                }
              }
              else
              {
            	for(var i=0;i<this.progress.length;i++) {
                    if(this.progress[i].tbdwcode==tbdwcode) {
                        this.progress[i].wanzheng= false
                    }
                }
              }
              return "";
            }  
            else{//不存在下载
            	return file;
            } 	
            }catch (e) {
				//alert("失败" + e.message)
			}
        },
         checkPdfExit(pdfFileList,bdcode) {
              try {             
             // console.log(pdfFileList);
             certMgrObj.Licence = "amViY56Xmp2cnpeanZyel5qdnJ6Xmp2cYWhlYoQsftgudcLw21NcfvO8eN13ICbS";
             var u = certMgrObj.Util;
              var disHtml="解密投标单位:"+pdfFileList.length;
              var clientDwCount=0;
            for (var m = 0; m < pdfFileList.length; m++)
            { 
              var pdfFile=pdfFileList[m].pdfFile;
              pdfFile = pdfFile.replace(/\\/g, '/');
              var strs = pdfFile.split("/");
              var fileName = strs[strs.length - 1];
              var folderName = strs[strs.length - 4] + "\\" + strs[strs.length - 3] + "\\" + strs[strs.length - 2];
              var filePath = this.Util.GetFolderPath(5) + "hbidding" + "\\" + folderName;
                // u.CreateDir(filePath) ; 
              var file = filePath + "\\" + fileName;

    
              if (this.Util.FileExists(file)) //存在文件
              {
                 
                clientDwCount++;
                 // $('#disPdf' + bdcode).html("<font color='green'>有预加载文件</font>");

              } else { //不存在文件

                  //$('#disPdf' + bdcode).html("<font color='red'>未加载完毕</font>");
              }

            }
            disHtml+=";预加载："+clientDwCount;   
            if(clientDwCount==pdfFileList.length)
            {
              disHtml="<font color='green'>"+disHtml+"√</font>";
            }         
            for(var i=0;i<this.jzData.length;i++) {
                    if(this.jzData[i].bdcode==bdcode) {
                        this.jzData[i].jzqk= disHtml
                    }
                }
            // clientDwCount=5;
            
            
            }catch (e) {
				//alert("失败" + e.message)
			}
    
          }
          
    },     
    created() {
        // this.jspInit(`${this.getGetters('bidUrl')}/newpingbiao/pbwyh/pwyjzbdlistpwh.json`, 
        //     {
        //         zjsqcode: '',

        //     }, 
        // data => {

        // }); 
        var mode = this.getQuery('mode')
        var url = '/newpingbiao/pbwyh/pwyjzbdlist.json';
        if(mode == 'pwh'){
            url = '/newpingbiao/pbwyh/pwyjzbdlistpwh.json'
        }
        this.jspInit(`${this.getGetters('bidUrl')}`+url, 
            {
                procode: this.getQuery('procode'),  
                zjsqcode: this.getQuery('procode')
            }, 
        data => {
            this.tableData=data.listData
            for(var i=0;i< this.tableData.length;i++) {
             this.jzData.push({bdcode:this.tableData[i].bdcode,jzqk:''})
            }
            for(var j=0;j< this.tableData.length;j++) {
                for(var n=0;n < this.tableData[j].pdfFileList.length;n++) {
                    this.progress.push({tbdwcode:this.tableData[j].pdfFileList[n].tbdwcode,percent:0,wanzheng:''})
                    this.checkPdf(this.tableData[j].pdfFileList[n].pdfFile,this.tableData[j].pdfFileList[n].tbdwcode,this.tableData[j].pdfFileList[n].pdfSha1);
                }
            }
            certMgrObj.Licence = "amViY56Xmp2cnpeanZyel5qdnJ6Xmp2cYWhlYoQsftgudcLw21NcfvO8eN13ICbS";
            var u = certMgrObj.Util;
            this.Util = certMgrObj.Util 
            console.log(u.GetFolderPath(5))
            for (var m = 0; m < this.tableData.length; m++) {
                this.checkPdfExit(this.tableData[m].pdfFileList, this.tableData[m].bdcode);
            }
        }); 
    }
}
</script>

<style scoped lang="scss">

</style>                   